<template>
  <main class="company" data-section-snap="">

    <section class="sub-hero">
      <div class="hero-wrap">
        <div class="sub-hero-copy">
          <h1 class="hero-title" data-i18n="company-hero-title" v-html="$rt('company-hero-title')"></h1>
          <p class="hero-desc" data-i18n="company-hero-desc" v-html="$rt('company-hero-desc')"></p>
        </div>
      </div>
    </section>

    <section class="statement fade-up">
      <div class="section-wrap col">
        <div class="statement-inner">
          <h2 class="statement-title" data-i18n="company-statement-title" v-html="$rt('company-statement-title')"></h2>
          <p class="statement-desc" data-i18n="company-statement-desc" v-html="$rt('company-statement-desc')"></p>
          <p class="company-byline"><strong>이동훈</strong> / 코드프레소 대표</p>
        </div>
      </div>
    </section>

    <section class="about is-dark fade-up" data-journey-stage="">
      <div class="section-wrap row is-sticky">
        <div class="section-aside">
          <div class="section-title text-left">
            <h2 data-i18n="company-about-title" v-html="$rt('company-about-title')"></h2>
          </div>

          <div class="journey-stage company-eras">
            <article class="journey-step is-active" data-journey-step="0">
              <h3 class="company-era-title" data-i18n="company-about-era-title-01" v-html="$rt('company-about-era-title-01')"></h3>
              <p class="company-era-desc" data-i18n="company-about-era-desc-01" v-html="$rt('company-about-era-desc-01')"></p>
              <figure class="company-era-image">
                <img src="/images/company/history/회사연혁01.png" alt="㈜코드프레소 설립 당시 사무실" loading="lazy">
              </figure>
            </article>

            <article class="journey-step" data-journey-step="1">
              <h3 class="company-era-title" data-i18n="company-about-era-title-02" v-html="$rt('company-about-era-title-02')"></h3>
              <p class="company-era-desc" data-i18n="company-about-era-desc-02" v-html="$rt('company-about-era-desc-02')"></p>
              <figure class="company-era-image">
                <img src="/images/company/history/회사연혁02.png" alt="온라인 학습 플랫폼 화면" loading="lazy">
              </figure>
            </article>

            <article class="journey-step" data-journey-step="2">
              <h3 class="company-era-title" data-i18n="company-about-era-title-03" v-html="$rt('company-about-era-title-03')"></h3>
              <p class="company-era-desc" data-i18n="company-about-era-desc-03" v-html="$rt('company-about-era-desc-03')"></p>
              <figure class="company-era-image">
                <img src="/images/company/history/회사연혁03.png" alt="정보보호 경영시스템 화면" loading="lazy">
              </figure>
            </article>

            <article class="journey-step" data-journey-step="3">
              <h3 class="company-era-title" data-i18n="company-about-era-title-04" v-html="$rt('company-about-era-title-04')"></h3>
              <p class="company-era-desc" data-i18n="company-about-era-desc-04" v-html="$rt('company-about-era-desc-04')"></p>
              <figure class="company-era-image">
                <img src="/images/company/history/회사연혁04.jpg" alt="역량 인증 리포트 화면" loading="lazy">
              </figure>
            </article>

            <article class="journey-step" data-journey-step="4">
              <h3 class="company-era-title" data-i18n="company-about-era-title-05" v-html="$rt('company-about-era-title-05')"></h3>
              <p class="company-era-desc" data-i18n="company-about-era-desc-05" v-html="$rt('company-about-era-desc-05')"></p>
              <figure class="company-era-image">
                <img src="/images/company/history/회사연혁05.webp" alt="AI 역량 진단 화면" loading="lazy">
              </figure>
            </article>
          </div>
        </div>

        <div class="company-years">
          <div class="company-year" data-journey-track-step="0">
            <p class="company-year-num">2019</p>
            <ul class="company-year-list desc">
              <li data-i18n="company-about-year-item-01-01" v-html="$rt('company-about-year-item-01-01')"></li>
              <li data-i18n="company-about-year-item-01-02" v-html="$rt('company-about-year-item-01-02')"></li>
            </ul>
          </div>

          <div class="company-year" data-journey-track-step="1">
            <p class="company-year-num">2021</p>
            <ul class="company-year-list desc">
              <li data-i18n="company-about-year-item-02-01" v-html="$rt('company-about-year-item-02-01')"></li>
              <li data-i18n="company-about-year-item-02-02" v-html="$rt('company-about-year-item-02-02')"></li>
            </ul>
          </div>

          <div class="company-year" data-journey-track-step="2">
            <p class="company-year-num">2023</p>
            <ul class="company-year-list desc">
              <li data-i18n="company-about-year-item-03-01" v-html="$rt('company-about-year-item-03-01')"></li>
              <li data-i18n="company-about-year-item-03-02" v-html="$rt('company-about-year-item-03-02')"></li>
            </ul>
          </div>

          <div class="company-year" data-journey-track-step="3">
            <p class="company-year-num">2024</p>
            <ul class="company-year-list desc">
              <li data-i18n="company-about-year-item-04-01" v-html="$rt('company-about-year-item-04-01')"></li>
              <li data-i18n="company-about-year-item-04-02" v-html="$rt('company-about-year-item-04-02')"></li>
              <li data-i18n="company-about-year-item-04-03" v-html="$rt('company-about-year-item-04-03')"></li>
              <li data-i18n="company-about-year-item-04-04" v-html="$rt('company-about-year-item-04-04')"></li>
            </ul>
          </div>

          <div class="company-year" data-journey-track-step="4">
            <p class="company-year-num">2026</p>
            <ul class="company-year-list desc">
              <li data-i18n="company-about-year-item-05-01" v-html="$rt('company-about-year-item-05-01')"></li>
              <li data-i18n="company-about-year-item-05-02" v-html="$rt('company-about-year-item-05-02')"></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="company-years-mobile">
        <div class="company-year-block">
          <p class="company-year-num">2019</p>
          <ul class="company-year-list desc">
            <li data-i18n="company-about-year-item-01-01" v-html="$rt('company-about-year-item-01-01')"></li>
            <li data-i18n="company-about-year-item-01-02" v-html="$rt('company-about-year-item-01-02')"></li>
          </ul>
          <figure class="company-era-image">
            <img src="/images/company/history/회사연혁01.png" alt="㈜코드프레소 설립 당시 사무실" loading="lazy">
          </figure>
        </div>

        <div class="company-year-block">
          <p class="company-year-num">2021</p>
          <ul class="company-year-list desc">
            <li data-i18n="company-about-year-item-02-01" v-html="$rt('company-about-year-item-02-01')"></li>
            <li data-i18n="company-about-year-item-02-02" v-html="$rt('company-about-year-item-02-02')"></li>
          </ul>
          <figure class="company-era-image">
            <img src="/images/company/history/회사연혁02.png" alt="온라인 학습 플랫폼 화면" loading="lazy">
          </figure>
        </div>

        <div class="company-year-block">
          <p class="company-year-num">2023</p>
          <ul class="company-year-list desc">
            <li data-i18n="company-about-year-item-03-01" v-html="$rt('company-about-year-item-03-01')"></li>
            <li data-i18n="company-about-year-item-03-02" v-html="$rt('company-about-year-item-03-02')"></li>
          </ul>
          <figure class="company-era-image">
            <img src="/images/company/history/회사연혁03.png" alt="정보보호 경영시스템 화면" loading="lazy">
          </figure>
        </div>

        <div class="company-year-block">
          <p class="company-year-num">2024</p>
          <ul class="company-year-list desc">
            <li data-i18n="company-about-year-item-04-01" v-html="$rt('company-about-year-item-04-01')"></li>
            <li data-i18n="company-about-year-item-04-02" v-html="$rt('company-about-year-item-04-02')"></li>
            <li data-i18n="company-about-year-item-04-03" v-html="$rt('company-about-year-item-04-03')"></li>
            <li data-i18n="company-about-year-item-04-04" v-html="$rt('company-about-year-item-04-04')"></li>
          </ul>
          <figure class="company-era-image">
            <img src="/images/company/history/회사연혁04.jpg" alt="역량 인증 리포트 화면" loading="lazy">
          </figure>
        </div>

        <div class="company-year-block">
          <p class="company-year-num">2026</p>
          <ul class="company-year-list desc">
            <li data-i18n="company-about-year-item-05-01" v-html="$rt('company-about-year-item-05-01')"></li>
            <li data-i18n="company-about-year-item-05-02" v-html="$rt('company-about-year-item-05-02')"></li>
          </ul>
          <figure class="company-era-image">
            <img src="/images/company/history/회사연혁05.webp" alt="AI 역량 진단 화면" loading="lazy">
          </figure>
        </div>
      </div>
    </section>

    <section class="features-trust fade-up">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <h2 data-i18n="company-features-trust-title" v-html="$rt('company-features-trust-title')"></h2>
          <p class="desc" data-i18n="company-features-trust-desc" v-html="$rt('company-features-trust-desc')"></p>
        </div>
        <div class="section-content">
          <ul class="company-cert-list">
            <li>
              <img src="/images/clients/trust-badges/polycon_ISO.CK4StHQ0.webp" alt="ISO 27001" width="150" height="150" loading="lazy">
              <span class="tag outline">ISO 27001</span>
            </li>
            <li>
              <img src="/images/clients/trust-badges/polycon_GDPR.CMMwSG4W.webp" alt="GDPR Compliant" width="150" height="150" loading="lazy">
              <span class="tag outline">GDPR Compliant</span>
            </li>
            <li>
              <img src="/images/clients/trust-badges/polycon_EdisonAwards.Dn1M22gL.webp" alt="Edison Awards" width="150" height="150" loading="lazy">
              <span class="tag outline">Edison Awards</span>
            </li>
            <li>
              <img src="/images/clients/trust-badges/polycon_AWS.C1SjntDs.webp" alt="AWS Partner" width="150" height="150" loading="lazy">
              <span class="tag outline">AWS Partner</span>
            </li>
            <li>
              <img src="/images/clients/trust-badges/polycon_SK.AwBggpGo.webp" alt="SK telecom" width="150" height="150" loading="lazy">
              <span class="tag outline">SK telecom</span>
            </li>
            <li>
              <img src="/images/clients/trust-badges/polycon_tomorrow.Cljz7fuY.webp" alt="Tomorrow Street" width="150" height="150" loading="lazy">
              <span class="tag outline">Tomorrow Street</span>
            </li>
            <li>
              <img src="/images/clients/trust-badges/polycon_GDIN.CtY4LoxM.webp" alt="GDIN" width="150" height="150" loading="lazy">
              <span class="tag outline">GDIN</span>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="about-offices fade-up is-dark">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <h2 data-i18n="company-about-offices-title" v-html="$rt('company-about-offices-title')"></h2>
          <p class="desc" data-i18n="company-about-offices-desc" v-html="$rt('company-about-offices-desc')"></p>
        </div>
        <div class="section-content">
          <div class="offices-map" aria-hidden="true">
            <img class="offices-map-bg" src="/images/company/about/world-map.svg" alt="" loading="lazy">
            <ul class="offices-pins">
              <li class="offices-pin" style="--pin-x: 87%; --pin-y: 45%;">
                <span class="offices-pin-ring"></span>
                <img class="offices-pin-mark" src="/images/company/about/Mark.svg" alt="">
                <span class="offices-pin-label" data-i18n="company-about-offices-mock-01" v-html="$rt('company-about-offices-mock-01')"></span>
              </li>
              <li class="offices-pin" style="--pin-x: 50%; --pin-y: 39%;">
                <span class="offices-pin-ring"></span>
                <img class="offices-pin-mark" src="/images/company/about/Mark.svg" alt="">
                <span class="offices-pin-label" data-i18n="company-about-offices-mock-02" v-html="$rt('company-about-offices-mock-02')"></span>
              </li>
              <li class="offices-pin" style="--pin-x: 47%; --pin-y: 36%;">
                <span class="offices-pin-ring"></span>
                <img class="offices-pin-mark" src="/images/company/about/Mark.svg" alt="">
                <span class="offices-pin-label" data-i18n="company-about-offices-mock-03" v-html="$rt('company-about-offices-mock-03')"></span>
              </li>
            </ul>
          </div>
          <ul class="company-offices">
            <li class="content-panel content-panel--compact">
                  <h4 data-i18n="company-about-offices-item-title-01" v-html="$rt('company-about-offices-item-title-01')"></h4>
                  <p class="desc-sm" data-i18n="company-about-offices-item-desc-01" v-html="$rt('company-about-offices-item-desc-01')"></p>
            </li>
            <li class="content-panel content-panel--compact">
                <div class="content-panel__intro">
                  <h4 data-i18n="company-about-offices-item-title-02" v-html="$rt('company-about-offices-item-title-02')"></h4>
                  <p class="desc-sm" data-i18n="company-about-offices-item-desc-02" v-html="$rt('company-about-offices-item-desc-02')"></p>
                </div>
            </li>
            <li class="content-panel content-panel--compact">
                <div class="content-panel__intro">
                  <h4 data-i18n="company-about-offices-item-title-03" v-html="$rt('company-about-offices-item-title-03')"></h4>
                  <p class="desc-sm" data-i18n="company-about-offices-item-desc-03" v-html="$rt('company-about-offices-item-desc-03')"></p>
                </div>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="outcomes fade-up">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <h2 data-i18n="company-outcomes-title" v-html="$rt('company-outcomes-title')"></h2>
          <p class="desc" data-i18n="company-outcomes-desc" v-html="$rt('company-outcomes-desc')"></p>
        </div>
        <div class="section-content">
          <div class="proof-card-stage">
            <div class="proof-card-deck" data-proof-deck="">
              <button type="button" class="proof-card-nav" aria-label="이전 후기 보기"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>
              <div class="proof-card-deck-list">
                <article class="proof-card">
                  <h3 data-i18n="company-outcomes-item-title-01" v-html="$rt('company-outcomes-item-title-01')"></h3>
                  <blockquote data-i18n="company-outcomes-item-quote-01" v-html="$rt('company-outcomes-item-quote-01')"></blockquote>
                  <cite>벡터 코리아 | 아카데미 시니어 매니저</cite>
                </article>
                <article class="proof-card">
                  <h3 data-i18n="company-outcomes-item-title-02" v-html="$rt('company-outcomes-item-title-02')"></h3>
                  <blockquote data-i18n="company-outcomes-item-quote-02" v-html="$rt('company-outcomes-item-quote-02')"></blockquote>
                  <cite>기술교육팀 | 책임매니저</cite>
                </article>
                <article class="proof-card">
                  <h3 data-i18n="company-outcomes-item-title-03" v-html="$rt('company-outcomes-item-title-03')"></h3>
                  <blockquote data-i18n="company-outcomes-item-quote-03" v-html="$rt('company-outcomes-item-quote-03')"></blockquote>
                  <cite>품질본부 | 교육담당자</cite>
                </article>
                <article class="proof-card">
                  <h3 data-i18n="company-outcomes-item-title-04" v-html="$rt('company-outcomes-item-title-04')"></h3>
                  <blockquote data-i18n="company-outcomes-item-quote-04" v-html="$rt('company-outcomes-item-quote-04')"></blockquote>
                  <cite>SW교육 | SME</cite>
                </article>
              </div>
              <button type="button" class="proof-card-nav" aria-label="다음 후기 보기"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="cta-final fade-up">
      <div class="section-wrap col cta-final-inner">
        <h2 class="cta-final-title" data-i18n="company-cta-final-title" v-html="$rt('company-cta-final-title')"></h2>
        <p class="cta-final-desc" data-i18n="company-cta-final-desc" v-html="$rt('company-cta-final-desc')"></p>
        <div class="cta-final-actions">
          <a class="btn btn-lg" href="https://codepresso.io/home/contact">
            <span data-i18n="company-cta-final-cta" v-html="$rt('company-cta-final-cta')"></span>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </a>
        </div>
      </div>
    </section>

  </main>

  <ClientInteractions :scripts='["js/fade-up.js","js/header-scroll.js","js/nav-menu.js","js/journey-stage.js","js/proof-card-slider.js","js/section-snap.js"]' />
</template>

<script setup lang="ts">
import ClientInteractions from '../components/ClientInteractions.vue'
import { useRenewalText } from '../composables/useRenewalText'
import ko from '../data/i18n-dist/Company/ko.json'
import en from '../data/i18n-dist/Company/en.json'
import ja from '../data/i18n-dist/Company/ja.json'
import vi from '../data/i18n-dist/Company/vi.json'
import es from '../data/i18n-dist/Company/es.json'

// 문자열은 data/i18n-dist 에서 온다 — 마크업은 키만 들고 있다.
const $rt = useRenewalText({ ko, en, ja, vi, es })
</script>
